module.exports = __webpack_public_path__ + "static/img/security01.dd175b21.png";